// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon_1[data-v-4d5fbc26]{height:132px;animation:rotate-4d5fbc26 1.25s linear infinite}@keyframes rotate-4d5fbc26{to{transform:rotate(-1turn)}}.icon_2[data-v-4d5fbc26]{width:80px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
